import React from 'react';

// The ORchestrate mark: an orange ring around a blue crosshair/network node with four filled
// blue nodes. Matches the brand logo. Transparent background so it works on any theme.
export const BrandLogoMark: React.FC<{ size?: number; className?: string }> = ({ size = 26, className }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none" aria-hidden="true" className={className}>
    <circle cx="60" cy="60" r="54" stroke="#d97706" strokeWidth="6" fill="none" />
    <line x1="60" y1="51" x2="60" y2="28" stroke="#4a9fd4" strokeWidth="5" strokeLinecap="round" />
    <line x1="60" y1="69" x2="60" y2="92" stroke="#4a9fd4" strokeWidth="5" strokeLinecap="round" />
    <line x1="51" y1="60" x2="28" y2="60" stroke="#4a9fd4" strokeWidth="5" strokeLinecap="round" />
    <line x1="69" y1="60" x2="92" y2="60" stroke="#4a9fd4" strokeWidth="5" strokeLinecap="round" />
    <circle cx="60" cy="22" r="8" fill="#4a9fd4" />
    <circle cx="60" cy="98" r="8" fill="#4a9fd4" />
    <circle cx="22" cy="60" r="8" fill="#4a9fd4" />
    <circle cx="98" cy="60" r="8" fill="#4a9fd4" />
    <circle cx="60" cy="60" r="11" stroke="#4a9fd4" strokeWidth="5" fill="none" />
  </svg>
);

// The "ORchestrate" wordmark: OR in orange, chestrate in blue (styled via .brand-or / .brand-rest).
export const BrandWordmark: React.FC = () => (
  <span><span className="brand-or">OR</span><span className="brand-rest">chestrate</span></span>
);
